import BillGroupModel from '../model/BillGroupModel'
import BillModel from '../model/BillModel'

export function visitApplyBill () {
  let billGroup = new BillGroupModel()
  let billModel = new BillModel()
  let now = new Date()
  return ([
    {
      ...billGroup,
      isForm: true,
      group: '申请信息',
      showBillFields: [
        {
          ...billModel,
          type: 'S',
          caption: '姓名',
          field: 'name',
          readOnly: 'F',
          value: '',
          display: '',
          defValue: '',
          allowBlank: 'F',
        },
        {
          ...billModel,
          type: 'S',
          caption: '身份证号',
          field: 'idCard',
          readOnly: 'F',
          value: '',
          display: '',
          defValue: '',
          allowBlank: 'F',
        },
        {
          ...billModel,
          type: 'N',
          caption: '手机号',
          field: 'mobile',
          readOnly: 'F',
          value: '',
          display: '',
          defValue: '',
          allowBlank: 'F',
          // inputType: 'phone',
        },
        {
          ...billModel,
          type: 'XS',
          caption: '被拜访人',
          field: 'objectName',
          readOnly: 'F',
          value: '',
          display: '',
          defValue: '',
          allowBlank: 'F',
          courseList:[{label: '春',value: '春'},
                        {label: '夏',value: '夏'}]
        },
        {
          ...billModel,
          type: 'D',
          caption: '拜访日期',
          field: 'visitTime',
          readOnly: 'F',
          value: now.getFullYear() + '-' + (now.getMonth() + 1) + '-' +
            now.getDate(),
          display: now.getTime(),
          defValue: '',
          allowBlank: 'F',
        },
        {
          ...billModel,
          type: 'S',
          caption: '拜访原因',
          field: 'reason',
          readOnly: 'F',
          value: '',
          display: '',
          defValue: '',
          allowBlank: 'F',
        },
      ],
      hideBillFields: [
        {
          ...billModel,
          type: 'S',
          caption: '拜访者ID',
          field: 'visitorId',
          readOnly: 'T',
          value: '',
          display: '',
          defValue: '',
          allowBlank: 'T',
        },
        {
          ...billModel,
          type: 'S',
          caption: '被拜访对象ID',
          field: 'objectId',
          readOnly: 'T',
          value: '',
          display: '',
          defValue: '',
          allowBlank: 'T',
        },
        {
          ...billModel,
          type: 'S',
          caption: '微信openid',
          field: 'openid',
          readOnly: 'T',
          value: '',
          display: '',
          defValue: '',
          allowBlank: 'T',
        },
        {
          ...billModel,
          type: 'S',
          caption: '学校ID',
          field: 'schoolId',
          readOnly: 'T',
          value: '',
          display: '',
          defValue: '',
          allowBlank: 'T',
        },
        {
          ...billModel,
          type: 'S',
          caption: '公众号ID',
          field: 'appId',
          readOnly: 'T',
          value: '',
          display: '',
          defValue: '',
          allowBlank: 'T',
        },
        {
          ...billModel,
          type: 'S',
          caption: '截止拜访时间',
          field: 'visitEndTime',
          readOnly: 'T',
          value: null,
          display: null,
          defValue: null,
          allowBlank: 'T',
        },
      ],
    },
  ])
}
